module.exports = __webpack_public_path__ + "static/img/hall_2.b4ef218.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/hall_2.jpg
// module id = 0Wki
// module chunks = 3